export const SET_LOCAL_AUDIO = "SET_LOCAL_AUDIO";
export const SET_LOCAL_VIDEO = "SET_LOCAL_VIDEO";
export const SET_BACKGROUND_FILTER = "SET_BACKGROUND_FILTER";